/* eslint-disable camelcase */
<template>
  <div class="baseForm">
    <div class="formDom">
      <Form ref="caseBaseForm" :dataSource="getBaseForm" id="caseBaseForm">
        <template v-slot:address>
          <a-alert
            v-show="checkDisplay('detailAddress')"
            style="margin:5px 0 0 10px"
            message="请填详细地址，如XX街道XX小区101"
            type="warning"
            show-icon
          />
        </template>
        <template v-slot:assitLog>
          <div class="table" style="margin-top:10px;">
            <div class="personList">
              <a-table
                :columns="logColumns"
                :data-source="initData.assitLog || []"
                :pagination="false"
                :rowKey="(record) => record.process_base_id"
              >
                <span slot="num" slot-scope="text, data, index">{{ index + 1 }}</span>
                <!-- <span slot="action" slot-scope="text, data">
                  <a @click="show(data)">查看</a>
                </span>-->
              </a-table>
            </div>
          </div>
        </template>
      </Form>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import Form from '@/components/GlobalForm'
import { forms } from './formData'
import { checkPhone, checkEmail, checkZip } from '@/utils/checkFun'
import { message } from 'ant-design-vue'
const logColumns = [
  {
    title: '时间',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '业务事项',
    dataIndex: 'yewushixiang',
    key: 'process_base_title'
  },
  {
    title: '帮扶金额(元)',
    dataIndex: 'bangfujine',
    key: 'process_type'
  },
  {
    title: '操作机构',
    dataIndex: 'caozuojigou',
    key: 'process_status'
  }
  // ,
  // {
  //   title: '操作',
  //   key: 'action',
  //   width: '80px',
  //   scopedSlots: { customRender: 'action' }
  // }
]

export default {
  name: 'Index',
  components: {
    Form
  },
  props: {
    initData: {
      // 父组件传过来的表单默认值
      type: Object,
      default: () => {
        return {}
      }
    },
    checkDisabled: {
      type: Function,
      default: () => { }
    },
    checkDisplay: {
      type: Function,
      default: () => { }
    },
    minzuList: {
      type: Array,
      default: () => []
    },
    pageType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      quZidianList: [],
      jinyongyuanyin_show: false,
      logColumns // 帮扶日志列表
      // cityList: [],
      // streetList: []
    }
  },
  watch: {
    initData() {
      this.setBfData()
    }
  },
  computed: {
    params() {
      return {
        // cityList: this.cityList || [],
        // streetList: this.streetList || [],
        checkDisabled: this.checkDisabled || (() => { }),
        checkDisplay: this.checkDisplay || (() => { }),
        numberChange: this.numberChange || (() => { }),
        checkTel: this.checkTel || (() => { }),
        checkEma: this.checkEma || (() => { })
        // checkZip: this.checkZip || (() => { })
      }
    },
    getBaseForm() {
      // 获取formData
      console.log('caseBaseForm的getBaseForm:' + this.initData.need_help_person_status)
      if (this.initData.need_help_person_status === '0') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        // alert('computed1')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.jinyongyuanyin_show = true
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        // alert('computed2')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.jinyongyuanyin_show = false
      }
      return forms.getBaseForm(this._.cloneDeep(this.initData), this.params, this.pageType, this.minzuList, this)
    }
  },
  mounted() {
    this.$nextTick(() => {
      request({
        url: `/process/getDistrictList`,
        method: 'post',
        data: {}
      }).then((ret) => {
        // console.log('原始区字段' + JSON.stringify(ret))
        // var test = ret
        // console.log('测试' + JSON.stringify(test))
        this.quZidianList = ret
        // console.log('区字段' + JSON.stringify(this.quZidianList))
        this.setBfData()
      })

      // alert(this.initData.need_help_person_disable_reason)
      // if (this.initData.need_help_person_status === '0') {
      //   this.jinyongyuanyin_show = true
      // }
    })
    // // 获取城市级联数据
    // if (!this.$store.getters.cityList || this.$store.getters.cityList.length <= 0) {
    //   this.$store.dispatch('GetProvincialCity').then(response => {
    //     this.cityList = response
    //   })
    // } else {
    //   this.cityList = this.$store.getters.cityList
    // }
    //
    // if (!this.$store.getters.streetList || this.$store.getters.streetList.length <= 0) {
    //   this.$store.dispatch('GetShanghaiCity').then(response => {
    //     this.streetList = response
    //   })
    // } else {
    //   this.streetList = this.$store.getters.streetList
    // }
  },
  methods: {
    setBfData() {
      // console.log('帮扶日志', JSON.stringify(this.initData.assitLog))
      // console.log('initData的值', JSON.stringify(this.initData))
      // var userInfo = this.$store.getters.userInfo ? this.$store.getters.userInfo.user : {}
      // console.log('用户信息', userInfo)
      this.initData.assitLog.forEach((item, index) => {
        // 为个案帮扶类型
        if (item.process_config_type === 'individualCase') {
          var yewushixiang = '个案帮扶'
          var bangfujine = JSON.parse(item.process_base_table_message).individual_case_support_funds
        }
        // 为项目帮扶类型
        if (item.process_config_type === 'projectFund' || item.process_config_type === 'projectActivity') {
          // eslint-disable-next-line no-redeclare
          var yewushixiang = item.process_base_title
          // eslint-disable-next-line no-redeclare
          var bangfujine = ''
          JSON.parse(item.process_base_table_message).need_help_person.forEach((item2, index2) => {
            // alert(item2.need_help_person_number_id)
            // alert(this.initData.need_help_person_number_id)
            if (item2.need_help_person_number_id === this.initData.need_help_person_number_id) {
              // alert(item2.need_help_assistance_amount)
              bangfujine = item2.need_help_assistance_amount
            }
          })
        }
        // eslint-disable-next-line no-unused-vars
        var caozuojigou = ''
        if (item.process_base_drafter.municipal_tree_level < 5) {
          caozuojigou = item.process_base_drafter.municipal_tree_name
        } else {
          var quhao = item.process_base_drafter.municipal_tree_level.substring(0, 2)

          // eslint-disable-next-line no-unused-vars
          var quname = ''
          this.quZidianList.forEach((item2, index2) => {
            if (item2.level === quhao) {
              quname = item2.title
            }
          })
          caozuojigou = quname + '--' + item.process_base_drafter.municipal_tree_name
        }

        this.initData.assitLog[index].yewushixiang = yewushixiang // '个案--' + (this.initData.need_help_person_name === undefined ? '' : this.initData.need_help_person_name)
          this.initData.assitLog[index].caozuojigou = caozuojigou
          if (this.initData.assitLog[index].current) {
              this.initData.assitLog[index].bangfujine = bangfujine + '-' + this.initData.assitLog[index].process_status + '-当前'
          } else {
              this.initData.assitLog[index].bangfujine = bangfujine + '-' + this.initData.assitLog[index].process_status
          }
      })
    },
    // 启用状态触发onchange事件
    qiyongzhuantaiOnchange(val) {
      // alert('qiyongzhuantaiOnchange' + val)
      this.initData.need_help_person_status = val
      this.jinyongyuanyin_show = val === '0'
      // this.initData.need_help_person_status = val
      // this.$set(this.initData, 'need_help_person_status', '0')
    },

    getValue(params) {
      // 获取数据
      const data = this.$refs.caseBaseForm.getFieldsValue(params)
      return data
    },
    onSubmit(params) {
      // 校验并获取数据
      if (this.initData.need_help_person_status === '0') {
        message.error('该帮扶对象已被禁用')
        return false
      }
      const data = this.$refs.caseBaseForm.handleSubmit(params)

      return data
    },
    // 姓名的onchange事件
    xingmingOnchange(value) {
      this.$emit('xingmingOnchange', value)
      // this.initData.need_help_person_name = value
      // this.setBfData()
    },
    numberChange(value, id) {
      let newValue = ''
      if (value < 18) {
        newValue = '未成年'
      } else if (value >= 18 && value <= 60) {
        newValue = '成年'
      } else {
        newValue = '老年'
      }
      setTimeout(() => {
        this.$refs.caseBaseForm.setFieldsValue(id, newValue)
      }, 0)
    },
    // 校验电话号码是否标准
    checkTel(rule, value, callback) {
      if (value && !checkPhone(value)) {
        const title = '请输入正确格式的号码'
        callback(title)
      } else {
        callback()
      }
    },
    // 校验邮箱格式
    checkEma(rule, value, callback) {
      if (value && !checkEmail(value)) {
        const title = '请输入正确格式的邮箱'
        callback(title)
      } else {
        callback()
      }
    },
    // 校验邮箱格式
    checkZip(rule, value, callback) {
      if (value && !checkZip(value)) {
        const title = '请输入正确格式的邮编'
        callback(title)
      } else {
        callback()
      }
    },
    show(record) {
      const params = {
        process_base_work_number: record.process_base_work_number,
        process_base_status: record.process_base_status
      }
      if (record.process_config_type && record.process_config_type === 'releaseOfFunds') {
        // 判断是什么流程，就跳到什么页面，资金帮扶流程
        // this.$router.push({
        //   path: '/assit/compositeAssit/increaseItem',
        //   query: { pageType: 'view', processData: JSON.stringify(params) }
        // })
        const routeUrl = this.$router.resolve({
          path: '/assit/compositeAssit/increaseItem',
          query: { pageType: 'view', processData: JSON.stringify(params) }
        })
        window.open(routeUrl.href, '_blank')
      } else if (
        record.process_config_type &&
        record.process_config_type === 'activityConfirmation'
      ) {
        // 活动帮扶
        // this.$router.push({
        //   path: '/assit/compositeAssit/activeAssit',
        //   query: { pageType: 'view', processData: JSON.stringify(params) }
        // })
        const routeUrl = this.$router.resolve({
          path: '/assit/compositeAssit/activeAssit',
          query: { pageType: 'view', processData: JSON.stringify(params) }
        })
        window.open(routeUrl.href, '_blank')
      } else if (record.process_config_type && record.process_config_type === 'individualCase') {
        // 个案帮扶
        // this.$router.push({
        //   path: '/assit/compositeAssit/increaseAssitPeople',
        //   query: { pageType: 'view', processData: JSON.stringify(params) }
        // })
        // window.location.reload()
        const routeUrl = this.$router.resolve({
          path: '/assit/compositeAssit/increaseAssitPeople',
          query: { pageType: 'view', processData: JSON.stringify(params) }
        })
        window.open(routeUrl.href, '_blank')
        // setTimeout(function () { window.location.reload()() }, 0)
      } else if (record.process_config_type && record.process_config_type === 'ghReleaseOfFunds') {
        // 资金帮扶-帮侬一把
        // this.$router.push({
        //   path: '/assit/compositeAssit/fundAssit',
        //   query: { pageType: 'view', processData: JSON.stringify(params) }
        // })
        const routeUrl = this.$router.resolve({
          path: '/assit/compositeAssit/fundAssit',
          query: { pageType: 'view', processData: JSON.stringify(params) }
        })
        window.open(routeUrl.href, '_blank')
      } else if (
        record.process_config_type &&
        record.process_config_type === 'ghActivityConfirmation'
      ) {
        // 活动帮扶-帮侬一把
        // this.$router.push({
        //   path: '/assit/compositeAssit/givemeActive',
        //   query: { pageType: 'view', processData: JSON.stringify(params) }
        // })
        const routeUrl = this.$router.resolve({
          path: '/assit/compositeAssit/givemeActive',
          query: { pageType: 'view', processData: JSON.stringify(params) }
        })
        window.open(routeUrl.href, '_blank')
      } else if (record.process_config_type && record.process_config_type === 'internalDocuments') {
        // 文件
        // this.$router.push({
        //   path: '/assit/contentManagement/increaseFile',
        //   query: { pageType: 'view', processData: JSON.stringify(params) }
        // })
        const routeUrl = this.$router.resolve({
          path: '/assit/contentManagement/increaseFile',
          query: { pageType: 'view', processData: JSON.stringify(params) }
        })
        window.open(routeUrl.href, '_blank')
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../style.less";
.formDom {
  .personList {
    position: relative;
    border: 1px solid #e8e8e8;
    /deep/ .ant-table-wrapper {
      border-radius: 2px;
    }
    /deep/ .ant-table-placeholder {
      border-bottom: none;
    }
  }
  /deep/ .ant-alert {
    padding: 5px 5px 5px 35px;
    font-size: 12px;
    .ant-alert-icon {
      top: 8px;
    }
  }
  .show {
    color: #3d73dd;
    cursor: pointer;
  }
  .show:hover {
    color: #4d86ff;
  }
}
</style>
